var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontalKey = function SvgHorizontalKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 13.615q-.671 0-1.143-.472A1.56 1.56 0 0 1 5.385 12q0-.671.472-1.143A1.56 1.56 0 0 1 7 10.385q.671 0 1.143.472T8.615 12t-.472 1.143A1.56 1.56 0 0 1 7 13.615M7 17.5q-2.289 0-3.894-1.606Q1.5 14.29 1.5 12q0-2.289 1.606-3.894Q4.71 6.5 7 6.5q1.608 0 2.908.83a5.5 5.5 0 0 1 1.984 2.17h9.002l2.5 2.5-3.846 3.827-1.856-1.394-1.903 1.413-1.953-1.346h-1.944a5.57 5.57 0 0 1-1.984 2.165Q8.608 17.5 7 17.5M7 16q1.439 0 2.491-.87 1.053-.869 1.375-2.13h3.442l1.44.996 1.954-1.429 1.698 1.299L21.266 12l-1-1h-9.4q-.322-1.261-1.375-2.13Q8.438 8 7 8 5.35 8 4.175 9.175T3 12t1.175 2.825T7 16"
  })));
};
export default SvgHorizontalKey;